import { render, staticRenderFns } from "./ServiceTitle.vue?vue&type=template&id=7a0111e3&scoped=true&"
import script from "./ServiceTitle.vue?vue&type=script&lang=js&"
export * from "./ServiceTitle.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTitle.vue?vue&type=style&index=0&id=7a0111e3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0111e3",
  null
  
)

export default component.exports